<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Options-->
<div class="TopOptions">
	<div class="column-group">
		<div class="column1">
			<!--Currently School Level Only-->
			<!--School-->
			<!-- <div class="column-item">
                <div>
                    <label class="column-item-label">School</label>
                </div>

                <div style="margin-left: 10px;">
                    <p-radioButton name="group1" [disabled]="IsLoading() == true || UserLevelID != 1" value="1" label="All Schools" [(ngModel)]="selectedGroupValue" (ngModelChange)="onSelectedGroupValueChange($event)"></p-radioButton>
                </div>

                <div style="margin-left: 10px;">
                    <p-radioButton name="group1" [disabled]="IsLoading() == true" value="2" label="Current School Only" [(ngModel)]="selectedGroupValue" (ngModelChange)="onSelectedGroupValueChange($event)"></p-radioButton>
                </div>
            </div> -->

			<!--Message-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Message</label>
				</div>

				<div style="margin-left: 10px">
					<p-colorPicker [(ngModel)]="Messagecolor" [disabled]="IsLoading() == true"></p-colorPicker>
				</div>

				<div style="margin-left: 2px">
					<input
						type="text"
						pInputText
						[(ngModel)]="Message"
						[style.color]="Messagecolor"
						maxlength="100"
						style="width: 640px"
						[disabled]="IsLoading() == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--Sound-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Sound</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedSoundSelector"
						style="font-size: smaller"
						[disabled]="IsLoading() == true"
						[(ngModel)]="SelectedSound"
						(ngModelChange)="onSoundChange($event)"
					>
						<option *ngFor="let r of lstSoundItems" [ngValue]="r">
							{{ r.SoundFile }}
						</option>
					</select>
				</div>

				<div style="margin-left: 5px">
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onPlay()" [disabled]="IsLoading() == true">Play</button>
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onStop()" [disabled]="IsLoading() == true">Stop</button>
				</div>

				<!-- 				   -->
				<!-- Display When Busy -->
				<!-- 				   -->
				<div style="margin-left: 15px; width: 20px" [style.display]="IsLoading() == true ? 'block' : 'none'">
					<img class="busy-img" src="assets/images/loading.gif" />
				</div>
			</div>

			<!--Alert Type-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Frequency</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<select
						class="form-control"
						name="SelectedAlertType"
						style="font-size: smaller"
						[(ngModel)]="SelectedAlertTypeID"
						[disabled]="IsLoading() == true"
					>
						<option *ngFor="let r of lstAlertType" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>

			<div class="column-item" *ngIf="SelectedAlertTypeID == 3">
				<div>
					<label class="column-item-label">Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate" [disabled]="IsLoading() == true"></p-calendar>
				</div>

				<div>
					<label class="column-item-label">End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate" [disabled]="IsLoading() == true"></p-calendar>
				</div>
			</div>

			<!--Priority-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Priority</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<select class="form-control" name="Priority" style="font-size: smaller" [(ngModel)]="Priority" [disabled]="IsLoading() == true">
						<option *ngFor="let r of lstPriority" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>

			<div class="column-item">
				<div>
					<label class="column-item-label">Scan Station Modes</label>
				</div>

				<div style="margin-left: 10px">
					<div class="ModeGrid">
						<input id="EntryMode" class="CHK" type="checkbox" [(ngModel)]="EntryMode" />
						<label for="EntryMode">Entry Mode</label>

						<input id="ExitMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="ExitMode" />
						<label for="ExitMode">Exit Mode</label>

						<input id="MealMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="MealMode" />
						<label for="MealMode">Meal Mode</label>

						<input id="AccessMode" class="CHK" type="checkbox" [(ngModel)]="AccessMode" />
						<label for="AccessMode">Access Mode</label>

						<input id="TimeStampMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="TimeStampMode" />
						<label for="TimeStampMode">Time Stamp Mode</label>

						<input id="EventEntryMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="EventEntryMode" />
						<label for="EventEntryMode">Event Mode (Entry)</label>

						<input id="EventExitMode" class="CHK" type="checkbox" [(ngModel)]="EventExitMode" />
						<label for="EventExitMode">Event Mode (Exit)</label>
					</div>
				</div>
			</div>

			<div class="column-item">
				<div>
					<label class="column-item-label">Notify Apps:</label>
				</div>

				<div style="margin-left: 10px">
					<div class="ModeGrid">
						<input id="ParentPortalSendNotification" class="CHK" type="checkbox" [(ngModel)]="ParentPortalSendNotification" />
						<label for="ParentPortalSendNotification">Parent Portal</label>

						<input id="StudentPortalSendNotification" class="CHK InnerColumn" type="checkbox" [(ngModel)]="StudentPortalSendNotification" />
						<label for="StudentPortalSendNotification">Student Portal</label>

						<input id="StaffPortalSendNotification" class="CHK InnerColumn" type="checkbox" [(ngModel)]="StaffPortalSendNotification" />
						<label for="StaffPortalSendNotification">Staff Portal</label>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading()" class="btn btn-primary" (click)="onAdd()">Add Reminder</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
